<script lang="ts">
  import { quadIn, quadOut, sineInOut } from 'svelte/easing';
  import { navigating } from '$app/stores';
  import { onMount } from 'svelte';
  import afterimage from '../../svelteDirectives/AfterImage';
  import inversefade from '../../svelteDirectives/InverseFade';
  import { disableScrollHandling } from '$app/navigation';
  import { TransitionStatus, delay, duration } from './PageTransitionStore';

  export let useGlobalTransitionStatus = false;
  export let key: string;

  let wrapper: Document | undefined;

  $: {
    if (wrapper) {
      if ($navigating) {
        wrapper.querySelector('body')?.classList.add('navigating');
      } else {
        wrapper.querySelector('body')?.classList.remove('navigating');
      }
    }
  }
  const updateStatus = (isTransitioning: boolean) => {
    if (useGlobalTransitionStatus) {
      TransitionStatus.set({ isTransitioning });
    }
  };

  onMount(async () => {
    wrapper = document;
  });
</script>

<!-- TODO remove the noise "AFTERIMAGE" transition -->
<div class="wrapper">
  {#key key}
    <svg
      class="noise"
      width="100%"
      height="100%"
      in:inversefade={{ opacity: 0.4, duration: $duration, delay: $delay, easing: sineInOut }}
      out:inversefade={{ opacity: 0.4, duration: $duration, easing: sineInOut }}
    >
      <filter id="noise" x="0%" y="0%" width="100%" height="100%">
        <feTurbulence
          baseFrequency=".003 .005"
          type="fractalNoise"
          seed={Math.random() * 1000}
          result="NOISE"
        />
        <feColorMatrix type="saturate" in="NOISE" values="0" />
      </filter>
      <rect x="0" y="0" width="100%" height="100%" filter="url(#noise)" fill="none" />
    </svg>
    <div
      class="contents"
      in:afterimage={{ amount: 20, opacity: 0, duration: $duration, delay: $delay, easing: quadIn }}
      out:afterimage={{ amount: 20, opacity: 0, duration: $duration, easing: quadOut }}
      on:outrostart={() => {
        updateStatus(true);
        disableScrollHandling();
      }}
      on:outroend={() => window.scrollTo(0, 0)}
      on:introend={() => updateStatus(false)}
    >
      <slot />
    </div>
  {/key}
</div>

<style lang="scss">
  .noise {
    position: fixed !important;
    transform: translate3d(0, 0, 0);
    max-width: 2800px;
    margin: 0 auto;
    top: 0;
    z-index: 99;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    pointer-events: none;
  }

  :global(body.navigating),
  :global(body.navigatin a),
  :global(body.navigating button) {
    cursor: progress !important;
  }

  .wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    .contents {
      grid-column: 1;
      grid-row: 1;
    }
  }
</style>
